import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { UseQueryGoalsCreatorsAndModifiersState } from '../../lib/hooks/useQueryGoalsCreatorsAndModifiers';
import { Goal, GoalStatus } from '../../types';

interface GoalsContextState {
  isLoading?: boolean;
  hasErrors?: boolean;
  goals: Goal[];
  selectedFiltersCount?: number;
  clearFilters: () => void;
  creators: string[];
  setCreators: (values: string[]) => unknown;
  modifiers: string[];
  setModifiers: (values: string[]) => unknown;
  states: string[];
  setStates: (values: string[]) => unknown;
  searchQuery: string;
  setSearchQuery: (nextValue: string) => void;
  status: GoalStatus;
  setStatus: (values: GoalStatus) => unknown;
  creatorAndModifiers: UseQueryGoalsCreatorsAndModifiersState;
}

export const DEFAULT_GOALS_QUERY_CONTEXT: GoalsContextState = {
  isLoading: false,
  hasErrors: false,
  goals: [],
  selectedFiltersCount: 0,
  clearFilters: noop,
  creators: [],
  setCreators: noop,
  modifiers: [],
  setModifiers: noop,
  states: [],
  setStates: noop,
  searchQuery: '',
  setSearchQuery: noop,
  status: GoalStatus.ALL,
  setStatus: noop,
  creatorAndModifiers: {
    errorMessage: undefined,
    hasError: false,
    isLoading: false,
    refetch: noop,
    goalsCreators: [],
    goalsModifiers: [],
  },
};

export const GoalsContext = createContext<GoalsContextState>(DEFAULT_GOALS_QUERY_CONTEXT);

export const useGoalsContext = (): GoalsContextState => {
  const context = useContext(GoalsContext);

  if (!context) {
    throw new Error('useGoals must be used within a GoalsProvider');
  }
  return context;
};
